export default "__VITE_ASSET__CTNySocF__"